import {Component, OnInit, ChangeDetectorRef} from "@angular/core";
import {NgbActiveModal, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {LoginServerService} from "src/app/layouts/public/login/services/login-server.service";
import {ZendeskService} from "../../services/zendesk.service";
import {ActivatedRoute, Router, RouterModule} from "@angular/router";
import {RaygunService} from "../../services/raygun.service";
import {ZendeskTicket} from "../../models/ZendeskTicket";
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import { isNullOrUndefined } from 'src/app/helpers/tools';
import {ImageFile} from "../../models/imageFile";
import {SharedModule} from "../../modules/shared.module";
import {CommonModule, NgForOf} from "@angular/common";
import {RecaptchaModule} from "ng-recaptcha-2";
import {FormsModule} from "@angular/forms";
import {QuickToolbarSettingsModel} from "@syncfusion/ej2-richtexteditor";
import {RichTextEditorAllModule} from "@syncfusion/ej2-angular-richtexteditor";
import {DeviceModel} from "../../models/DeviceModel";
import { SpinnerComponent } from "../spinner/spinner.component";

@Component({
    selector: 'app-zendesk-help',
    templateUrl: './zendesk-help.component.html',
    imports: [
        CommonModule,
        RecaptchaModule,
        SharedModule,
        FormsModule,
        RouterModule,
        NgbTooltip,
        RichTextEditorAllModule,
        FormsModule,
        NgForOf,
        SpinnerComponent,
    ]
})
export class ZendeskHelpComponent implements OnInit {
    constructor(public _modal: NgbActiveModal, private _loginService: LoginServerService, private _zendeskService: ZendeskService,
                public _router: Router, private _route: ActivatedRoute, private _raygunService: RaygunService,
                private _cdr: ChangeDetectorRef) {
    }

    public recaptcha: string;
    public recaptchaSiteKey: string;
    public ticket: ZendeskTicket = new ZendeskTicket();
    public isSaving: boolean = false;
    public emailValid: boolean = false;
    public subjectValid: boolean = false;
    public descriptionValid: boolean = false;
    public recaptchaValid: boolean = false;
    public showErrors: boolean = false;
    public success : boolean = null;
    public fileError : string = "";
    
    public canSendDiagInfo: boolean = true;
    public softwareVersion: string | null = null;
    public wifiConnected: boolean | null = null;
    public ethernetConnected: boolean | null = null;
    
    public errorCode: number | null = null;
    public previousRoute: string | null = null;

    public prePopSubject: string | null = null;

    private mailAddress: string = "mailto:help@fecpak.com";
    
    public editorTools = {
        items: ['Bold', 'Italic', 'SuperScript', 'SubScript', '|', 'ClearFormat', '|', 'Undo', 'Redo']
    };

    public subjects: string[] = [
        "Collecting a sample",
        "Inserting a cassette",
        "Internet or Wi-Fi",
        "Interpreting the result",
        "Logging in",
        "Uploading a sample",
        "Other"
    ];
    
    public async ngOnInit() {
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                action: "openHelp"
            },
            queryParamsHandling: 'merge'
        });
        if (this.isLoggedIn) {
            this.ticket.email = this._loginService.userToken.unique_name;
            var systemUserId = parseInt(this._loginService.userToken.Rata_SystemUserId);
            this.ticket.systemUserId = !Number.isNaN(systemUserId) ? systemUserId : null;
            
            var distributorId = parseInt(this._loginService.userToken.Rata_DistributorId);
            this.ticket.distributorId = !Number.isNaN(distributorId) ? distributorId : null;
            
            var groupId = parseInt(this._loginService.userToken.Rata_LaboratoryGroupId);
            this.ticket.groupId = !Number.isNaN(groupId) ? groupId : null;
            
            var siteId = parseInt(this._loginService.userToken.Rata_LaboratoryId);
            this.ticket.siteId = !Number.isNaN(siteId) ? siteId : null;
            
            var accountId = parseInt(this._loginService.userToken.Rata_AccountId);
            this.ticket.accountId = !Number.isNaN(accountId) ? accountId : null;
        } else {
            this.recaptchaSiteKey = await firstValueFrom(this._loginService.getRecaptchaSiteKey());
        }
        this.ticket.currentUrl = document.location.href.split("?")[0];
        this.softwareVersion = this._raygunService.raygunClientSettings.version;
        
        this._route.queryParams.subscribe(params => {
            if (!isNullOrUndefined(params['boardID']))
                this.ticket.boardIdentifier = params['boardID'];
            if (!isNullOrUndefined(params['version']))
                this.softwareVersion = params['version'];
            if (!isNullOrUndefined(params['wifi']))
                this.wifiConnected = params['wifi'] == "true";
            if (!isNullOrUndefined(params['ethernet']))
                this.ethernetConnected = params['ethernet'] == "true";
            if (!isNullOrUndefined(params['errorCode']))
                this.errorCode = params['errorCode'];
            if (!isNullOrUndefined(params['previousRoute']))
                this.previousRoute = params['previousRoute'];
            if (!isNullOrUndefined(params['subject']) && params['subject'].toLowerCase() != "null")
                this.prePopSubject = params['subject'];
        });
        
        if (this.prePopSubject) {
            this.subjects.push(this.prePopSubject);
            this.ticket.subject = this.prePopSubject;
            this.subjects.sort();
        }
    }

    resolved(captchaResponse: string) {
        this.recaptcha = captchaResponse;
    }

    // Handle reCAPTCHA expiration event
    public recaptchaExpired() {
        this.recaptcha = null;
        this.recaptchaValid = false;
        try {
            this._cdr.detectChanges();
        } catch (e) {
            // ignore
        }
    }
  
    ngAfterViewInit() {
        
    }

    ngOnDestroy() {
        
    }  
    
    public openFilePicker() {
        $("input[name='fileInput']").click();
    }
    
    public attachFile(event) {
        let files: File[] = event.target.files;
        const MAX_SIZE: number = 50000000;
        this.fileError = "";
        try {
            if (files) {
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    if (file) {
                        if (file.size < MAX_SIZE) {
                            const READER = new FileReader();
                            READER.readAsDataURL(file);
                            READER.onload = () => {
                                if (!this.ticket.attachments.find(x => x.url === READER.result as string)) {
                                    this.ticket.attachments.push(new ImageFile(file.name, READER.result as string));
                                }
                            }
                        } else {
                            this.fileError = "File: " + event.target.files[0].name + " is too large to upload.";
                        }
                    }
                }
            }
        } catch (e) {
            console.error(e.message);
        }
        $(event.target).val(null);
    }
    
    public removeFile(fileName: string) {
        if (this.ticket && this.ticket.attachments && this.ticket.attachments.length >= 1) {
            var file = this.ticket.attachments.find(x => x.name === fileName);
            var index = this.ticket.attachments.indexOf(file);
            if (index > -1) {
                this.ticket.attachments.splice(index, 1);
            }
        }
    }

    public get submitActive() {
        const reg = /^[^\s\.@]+(\.[^\s\.@]+)*@[^\s\.@]+(\.[^\s\.@]+)+$/;
        this.emailValid = reg.test(this.ticket.email);
        this.subjectValid = this.ticket.subject && this.ticket.subject.length >= 1;
        this.descriptionValid = this.ticket.description && this.ticket.description.length >= 1;
        this.recaptchaValid = this.recaptcha && this.recaptcha.length >= 1;
        return this.emailValid && this.subjectValid && this.descriptionValid && (!this.recaptchaSiteKey || this.recaptchaValid);
    }

    public async submit() {
        if (this.submitActive) {
            this.showErrors = false;
            this.isSaving = true;
            if (this.canSendDiagInfo)
                this.ticket.diagInfo = this.diagnosticInformation;
            this.success = await firstValueFrom(this._zendeskService.createTicket(this.ticket));
        } else {
            this.showErrors = true;
        }
        this.isSaving = false;
    }

    close() {
        this._router.navigate([], { relativeTo: this._route });
        this._modal.close();
    }
    
    public get isLoggedIn() {
        return !(!this._loginService.userToken.unique_name);
    }
    
    public get diagnosticInformation() {
        var table = `<table style='text-align:left'><tbody>`;
        if (this.errorCode)
            table += `<tr><th>Error code</th><td>${this.errorCode}</td></tr>`;
        
        if (this.previousRoute)
            table += `<tr><th>Previous route</th><td>${this.previousRoute}</td></tr>`;
        
        if (this.ticket.boardIdentifier)
            table += `<tr><th>${DeviceModel.ModelNameSentence}</th><td>${this.ticket.boardIdentifier}</td></tr>`;
        
        if (this.softwareVersion)
            table += `<tr><th>RATA Version</th><td>${this.softwareVersion}</td></tr>`;
        
        if (!isNullOrUndefined(this.ethernetConnected))
            table += `<tr><th>Connected via ethernet</th><td>${this.ethernetConnected == true ? 'Yes' : 'No'}</td></tr>`;
        
        if (!isNullOrUndefined(this.wifiConnected))
            table += `<tr><th>Connected via Wi-Fi</th><td>${this.wifiConnected == true ? 'Yes' : 'No'}</td></tr>`;
        
        table += `<tr><th>User ID</th><td>${this.ticket.systemUserId ? this.ticket.systemUserId : 'Not logged in'}</td></tr>`;
        
        if (this.ticket.distributorId) {
            table += `<tr><th>Distributor</th><td>D${this.ticket.distributorId}`;
            if (this._loginService.userToken.Rata_DistributorName)
                table += ` - ${this._loginService.userToken.Rata_DistributorName}`;
            table += `</td></tr>`;
        }
        
        if (this.ticket.groupId) {
            table += `<tr><th>Group</th><td>G${this.ticket.groupId}`;
            if (this._loginService.userToken.Rata_LaboratoryGroupName)
                table += ` - ${this._loginService.userToken.Rata_LaboratoryGroupName}`;
            table += `</td></tr>`;
        }
        
        if (this.ticket.siteId) {
            table += `<tr><th>Site</th><td>S${this.ticket.siteId}`;
            if (this._loginService.userToken.Rata_LaboratoryName)
                table += ` - ${this._loginService.userToken.Rata_LaboratoryName}`;
            table += `</td></tr>`;
        }
        
        if (this.ticket.accountId) {
            table += `<tr><th>Account</th><td>A${this.ticket.accountId}`;
            if (this._loginService.userToken.Rata_AccountName)
                table += ` - ${this._loginService.userToken.Rata_AccountName}`;
            table += `</td></tr>`;
        }
        
        table += `</tbody></table>`
        return table;
    }
    public mailTo() {
        window.location.href = this.mailAddress;
    }
}
